import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Highcharts from 'highcharts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import HC_exporting from "highcharts/modules/exporting";
import HC_Data from "highcharts/modules/export-data";
HC_exporting(Highcharts);
HC_Data(Highcharts);

@Component({
  selector: 'app-rrms-dashboard',
  templateUrl: './rrms-dashboard.component.html',
  styleUrls: ['./rrms-dashboard.component.scss']
})
export class RrmsDashboardComponent implements OnInit {
  rrmsDashboardForm: FormGroup;
  toggle = true;
  toggle1 = true;
  toggle2 = true;
  toggle3 = true;
  toggle4 = true;
  toggle5 = true;
  toggle6 = true;
  toggle7 = true;
  toggle8 = true;
  toggle9 = true;
  toggle10 = true;
  toggle11 = true;
  toggle12 = true;
  toggle13 = true;
  toggle14 = true;
  toggle15 = true;
  toggle16 = true;
  toggle17 = true;
  data1: any;
  data2: any;
  data3: any;
  data4: any;
  data5: any;
  data6: any;
  data7: any;
  data8: any;

  submitted = false;

  startDateVal: any;
  endDateVal: any;
  
  visitingCountryVal: any;
  visitingNetworkVal: any;
  visitingTadigVal: any;
  noOfDaysValue: any
  customerTypeVal: any;
  orgId: any;
  countryNameForGraph: any;
 
  country = []
  network = []
  dataSource = []
  VPMNCountry = []
  VPMNnetwork = []
  VPMNtadig = []
  HPMNtadig = []

  showTable: boolean;
  messageCategory = ["MessageCategory1", "MessageCategory2", "MessageCategory3"]
  vpmnCountryList: any;
  vpmnNetworkList: any;
  vpmnTadigList: any;
  callVPMNNetwork: boolean;
 
  constructor(private endPointService: EndpointsService,private router: Router,
    private endpointsService: EndpointsService,
    private backendApiService: BackendApiService, private spinnerService: Ng4LoadingSpinnerService,
    private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    setTimeout(() => {
      
    }, 10000);
    this.spinnerService.show();
    this.createFilterForm();
    this.getVPMNCountryDetails();
    // this.getDataFromAPI();
    this.onAll();
    this.getTadig();

  }

  createFilterForm() {
    this.rrmsDashboardForm = this.formBuilder.group({
      endDate: [''],
      startDate: [''],
      HPMNtadig: [''],
      customerType: [''],
      // offerStatus: [''],
      activeOfferDays: ['', [Validators.maxLength(4), Validators.pattern("^[0-9]*$")]],
      // startDate: [, [Validators.required]],
      // endDate: [, [Validators.required]],
      VPMNtadig: [''],
      country: [sessionStorage.getItem('homeCountryNameWithOp')],
      network: [sessionStorage.getItem('homeOp')],
      msgCatergory: ['all'],
      VPMNCountry: [''],
      VPMNnetwork: [''],
    });
  }


  onAll() {

    this.submitted = true;

    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;




    this.toggle = !this.toggle;
    this.onCountryClick('');
    this.countryNameForGraph = 'OverAll';

  }
  onAfghanistan() {
    this.toggle = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle1 = !this.toggle1;
    this.onCountryClick('7528');
    this.countryNameForGraph = 'Afghanistan';

  }
  onBenin() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle2 = !this.toggle2;
    this.onCountryClick('110');
    this.countryNameForGraph = 'Benin';

  }
  onCameroon() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle3 = !this.toggle3;
    this.onCountryClick('6054');
    this.countryNameForGraph = 'Cameroon';

  }
  onCongoRepublic() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle4 = !this.toggle4;
    this.onCountryClick('7590');
    this.countryNameForGraph = 'Congo Republic';

  }
  onGhana() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle5 = !this.toggle5;
    this.onCountryClick('274');
    this.countryNameForGraph = 'Ghana';

  }
  onGuinea() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle6 = !this.toggle6;
    this.onCountryClick('726');
    this.countryNameForGraph = 'Guinea';

  }
  onGuineaBissau() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle7 = !this.toggle7;
    this.onCountryClick('275');
    this.countryNameForGraph = 'Guinea Bissau';

  }
  onIvoryCoast() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle8 = !this.toggle8;
    this.onCountryClick('7343');
    this.countryNameForGraph = 'Ivory Coast';

  }
  onLiberia() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle9 = !this.toggle9;
    this.onCountryClick('5054');
    this.countryNameForGraph = 'Liberia';

  }
  onNigeria() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle10 = !this.toggle10;
    this.onCountryClick('128');
    this.countryNameForGraph = 'Nigeria';

  }
  onRawanda() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle11 = !this.toggle11;
    this.onCountryClick('7364');
    this.countryNameForGraph = 'Rwanda';

  }
  onSwaziland() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle12 = !this.toggle12;
    this.onCountryClick('7341');
    this.countryNameForGraph = 'Swaziland';

  }
  onSouthAfrica() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle13 = !this.toggle13;
    this.onCountryClick('7087');
    this.countryNameForGraph = 'South Africa';

  }
  onSouthSudan() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle14 = !this.toggle14;
    this.onCountryClick('7311');
    this.countryNameForGraph = 'South Sudan';

  }
  onSudan() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle16 = true;
    this.toggle17 = true;
    this.toggle15 = !this.toggle15;
    this.onCountryClick('7309');
    this.countryNameForGraph = 'Sudan';

  }
  onUganda() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle17 = true;
    this.toggle16 = !this.toggle16;
    this.onCountryClick('7530');
    this.countryNameForGraph = 'Uganda';

  }
  onZambia() {
    this.toggle = true;
    this.toggle1 = true;
    this.toggle2 = true;
    this.toggle3 = true;
    this.toggle4 = true;
    this.toggle5 = true;
    this.toggle6 = true;
    this.toggle7 = true;
    this.toggle8 = true;
    this.toggle9 = true;
    this.toggle10 = true;
    this.toggle11 = true;
    this.toggle12 = true;
    this.toggle13 = true;
    this.toggle14 = true;
    this.toggle15 = true;
    this.toggle16 = true;
    this.toggle17 = !this.toggle17;
    this.onCountryClick('7545');
    this.countryNameForGraph = 'Zambia';

  }
  onSearch() {
    setTimeout(() => {
      
    }, 10000);
    this.spinnerService.show();
    this.submitted = true;
    console.log('4', this.orgId);
    if (this.orgId == undefined) {

      this.orgId = '';
    }

    this.startDateVal = this.rrmsDashboardForm.get('startDate').value;
    this.endDateVal = this.rrmsDashboardForm.get('endDate').value;
    this.customerTypeVal = this.rrmsDashboardForm.get('customerType').value;
    this.visitingCountryVal = this.rrmsDashboardForm.get('VPMNCountry').value
    this.visitingNetworkVal = this.rrmsDashboardForm.get('VPMNnetwork').value;
    this.visitingTadigVal = this.rrmsDashboardForm.get('VPMNtadig').value;
    if(this.rrmsDashboardForm.get('activeOfferDays').value != null )
    {
      this.noOfDaysValue = this.rrmsDashboardForm.get('activeOfferDays').value;
    }
    else
    {
      this.noOfDaysValue = '';
    }

    console.log("date1", this.startDateVal);
    console.log("date2", this.endDateVal);
    if (this.startDateVal == null || this.startDateVal == "") {

      this.startDateVal = '';
    }
    else{
      this.startDateVal = this.startDateVal + 'T00:00'
    }
    if (this.endDateVal == null || this.endDateVal == "") {

      this.endDateVal = '';
    }
    else{
      this.endDateVal = this.endDateVal + 'T23:59'
    }
    if (this.noOfDaysValue == null) {

      this.noOfDaysValue = '';
    }


    if (this.visitingCountryVal == null || this.visitingCountryVal == "") {

      this.visitingCountryVal = '';
    }
    if (this.visitingNetworkVal == null || this.visitingNetworkVal == "") {

      this.visitingNetworkVal = '';
    }
    if (this.visitingTadigVal == null || this.visitingTadigVal == "") {

      this.visitingTadigVal = '';
    }
    if (this.customerTypeVal == null || this.customerTypeVal == "") {

      this.customerTypeVal = '';
    }
    // graph 1 
    let rrms_msisdn_count_reports = this.endPointService.URL_RRMS_MSISDN_COUNT_REPORTS
      + '&startDate=' + this.startDateVal + '&endDate=' + this.endDateVal + '&noofdays=' + this.noOfDaysValue + '&orgId=' + this.orgId
      +'&country='+this.visitingCountryVal
    +'&networkData='+ this.visitingNetworkVal
      + '&customerType=' + this.customerTypeVal
      // + '&offerStatus=' + this.rrmsDashboardForm.get('offerStatus').value
      + '&roamOrgId=' +  this.visitingTadigVal;

    this.backendApiService.callToApi(rrms_msisdn_count_reports).subscribe((data) => {
      this.msisdnCountBarGraph(data);
    });

    // graph 2 

    let rrms_datewise_msisdn_count_reports = this.endPointService.URL_RRMS_DATEWISE_MSISDN_COUNT_REPORTS
    + '&startDate=' + this.startDateVal + '&endDate=' + this.endDateVal + '&noofdays=' + this.noOfDaysValue 
  +'&orgId=' + this.orgId
  +'&country='+this.visitingCountryVal
    +'&networkData='+ this.visitingNetworkVal
  + '&customerType=' + this.customerTypeVal
  // + '&offerStatus=' + this.rrmsDashboardForm.get('offerStatus').value
  + '&roamOrgId=' +  this.visitingTadigVal ;

  this.backendApiService.callToApi(rrms_datewise_msisdn_count_reports).subscribe((data) => {
    this.datewiseMsisdnCountBarGraph(data);
  });

    // graph 3
    let pack_activation_success_reports = this.endPointService.URL_RRMS_PACK_ACTIVATION_SUCCESS_REPORTS
      + '&startDate=' + this.startDateVal + '&endDate=' + this.endDateVal + '&noofdays=' + this.noOfDaysValue + '&orgId=' + this.orgId
      + '&customerType=' + this.customerTypeVal
      +'&country='+this.visitingCountryVal
    +'&networkData='+ this.visitingNetworkVal
      // + '&offerStatus=' + this.rrmsDashboardForm.get('offerStatus').value
      + '&roamOrgId=' +  this.visitingTadigVal;
    this.backendApiService.callToApi(pack_activation_success_reports).subscribe((data) => {
      if(data.ByRegion != undefined && data.ByRegion.length>0){
      data.ByRegion[2]['yAxis'] = 1;
      data.ByRegion[2]['type'] = 'line';
      this.packActivationSuccessBarGraph(data);
      }
      else{
        
      this.packActivationSuccessBarGraph(data);
      }
    });

    // graph 4 

    let pack_activation_failure_reports = this.endPointService.URL_RRMS_PACK_ACTIVATION_FAILURE_REPORTS
      + '&startDate=' + this.startDateVal + '&endDate=' + this.endDateVal + '&noofdays=' + this.noOfDaysValue + '&orgId=' + this.orgId
      + '&customerType=' + this.customerTypeVal
      +'&country='+this.visitingCountryVal
    +'&networkData='+ this.visitingNetworkVal
      // + '&offerStatus=' + this.rrmsDashboardForm.get('offerStatus').value
      + '&roamOrgId=' +  this.visitingTadigVal;
    this.backendApiService.callToApi(pack_activation_failure_reports).subscribe((data) => {
      if(data.ByRegion[0]['data'].length ==0)
      {
        data ='[]';
        this.packActivationFailureBarGraph(data);
      }
      else{

        
        for (var i = 0; i < data.ByRegion[0]['data'].length; i++) {

          if (data.ByRegion[0]['data'][i].name == '') {
            data.ByRegion[0]['data'][i].name ='No Response' ;

          }
          if (data.ByRegion[0]['data'][i].name == '\"0' ) {
            data.ByRegion[0]['data'][i].name ='1005' ;

          }
          if (data.ByRegion[0]['data'][i].name == '777' ) {
            data.ByRegion[0]['data'][i].name ='no response' ;

          }
        }
      this.packActivationFailureBarGraph(data);
      }
    });

    // graph 5
    let pack_deactivation_success_reports = this.endPointService.URL_RRMS_PACK_DEACTIVATION_SUCCESS_REPORTS
      + '&startDate=' + this.startDateVal + '&endDate=' + this.endDateVal + '&noofdays=' + this.noOfDaysValue + '&orgId=' + this.orgId
      + '&customerType=' + this.customerTypeVal
      +'&country='+this.visitingCountryVal
    +'&networkData='+ this.visitingNetworkVal
      // + '&offerStatus=' + this.rrmsDashboardForm.get('offerStatus').value
      + '&roamOrgId=' +  this.visitingTadigVal;

    this.backendApiService.callToApi(pack_deactivation_success_reports).subscribe((data) => {
      if(data.ByRegion != undefined && data.ByRegion.length>0){
      data.ByRegion[2]['yAxis'] = 1;
      data.ByRegion[2]['type'] = 'line';
      this.packDeactivationSuccessBarGraph(data);
      }
      else{
        this.packDeactivationSuccessBarGraph(data);}
    });

    // graph 6 

    let pack_deactivation_failure_reports = this.endPointService.URL_RRMS_PACK_DEACTIVATION_FAILURE_REPORTS
      + '&startDate=' + this.startDateVal + '&endDate=' + this.endDateVal + '&noofdays=' + this.noOfDaysValue + '&orgId=' + this.orgId
      + '&customerType=' + this.customerTypeVal
      +'&country='+this.visitingCountryVal
    +'&networkData='+ this.visitingNetworkVal
      // + '&offerStatus=' + this.rrmsDashboardForm.get('offerStatus').value
      + '&roamOrgId=' +  this.visitingTadigVal;
    this.backendApiService.callToApi(pack_deactivation_failure_reports).subscribe((data) => {
      if(data.ByRegion[0]['data'].length ==0)
      {
        data ='[]';
        this.packDeactivationFailureBarGraph(data);
      }
      else{
        
        for (var i = 0; i < data.ByRegion[0]['data'].length; i++) {

          if (data.ByRegion[0]['data'][i].name == '') {
            data.ByRegion[0]['data'][i].name ='No Response' ;

          }
          if (data.ByRegion[0]['data'][i].name == '\"0' ) {
            data.ByRegion[0]['data'][i].name ='1005' ;

          }
          if (data.ByRegion[0]['data'][i].name == '777' ) {
            data.ByRegion[0]['data'][i].name ='no response' ;

          }
        }
      this.packDeactivationFailureBarGraph(data);
      }
    });
   

  }

  onCountryClick(data: any) {

  

    console.log(data);
    this.orgId = data;
    // this.rrmsDashboardForm.reset();
    this.rrmsDashboardForm.controls.VPMNCountry.setValue('');
    this.rrmsDashboardForm.controls.VPMNnetwork.setValue('');
    this.rrmsDashboardForm.controls.VPMNtadig.setValue('');
    this.rrmsDashboardForm.controls.startDate.setValue('');
    this.rrmsDashboardForm.controls.endDate.setValue('');
    this.rrmsDashboardForm.controls.customerType.setValue('');

    
    // if ( this.orgId == '274' ||  this.orgId == '110') {
    //   this.vpmnCountryList = [];
    //   this.vpmnNetworkList = [];
    //   this.vpmnTadigList = [];
    //   const apiUrl = 'https://loginapp1.tevas.in/TarrifServlet?reportType=getCountry' + '&userName=' + sessionStorage.getItem('ecowas_user_name');
    //   this.backendApiService.callToApi(apiUrl).subscribe(response => {
    //     this.vpmnCountryList = response;
    //   });
    // }

    // this.startDateVal = this.rrmsDashboardForm.get('startDate').value;
    // this.endDateVal = this.rrmsDashboardForm.get('endDate').value;


    // if(this.rrmsDashboardForm.get('activeOfferDays').value != null )
    // {
    //   this.noOfDaysValue = this.rrmsDashboardForm.get('activeOfferDays').value;
    // }
    // else
    // {
    //   this.noOfDaysValue = '';
    // }


    // if (this.startDateVal == null || this.startDateVal == "") {

    //   this.startDateVal = '';
    // }
    // else{
    //   this.startDateVal =  this.startDateVal + 'T00:00'
    // }
    // if (this.endDateVal == null || this.endDateVal == "") {

    //   this.endDateVal = '';
    // }
    // else{
    //   this.endDateVal =  this.endDateVal + 'T23:59'
    // }
    // if (this.noOfDaysValue == null) {

    //   this.noOfDaysValue = '';
    // }
    console.log("FIRST FILTER");
    // if (countryData) {
    //   url += "&country=" + countryData.trim()
    // }
    // // let networkData = this.roamerSegmentForm.get('network').value;
    // let networkData = this.roamerSegmentForm.get('VPMNnetwork').value;
    // if (networkData) {
    //   url += "&network=" + networkData
    // }
    // graph 1 
    let rrms_msisdn_count_reports = this.endPointService.URL_RRMS_MSISDN_COUNT_REPORTS
      // + '&startDate=' + this.startDateVal + '&endDate=' + this.endDateVal + '&noofdays=' + this.noOfDaysValue
    +'&orgId=' + data;
    // +'&country='+this.rrmsDashboardForm.get('VPMNCountry').value 
    // +'&networkData='+this.rrmsDashboardForm.get('VPMNnetwork').value
    // + '&customerType=' + this.rrmsDashboardForm.get('customerType').value 
    // + '&offerStatus=' + this.rrmsDashboardForm.get('offerStatus').value
    // + '&roamOrgId=' + this.rrmsDashboardForm.get('VPMNtadig').value ;

    this.backendApiService.callToApi(rrms_msisdn_count_reports).subscribe((data) => {
      this.msisdnCountBarGraph(data);
    });

    // graph 2 

    let rrms_datewise_msisdn_count_reports = this.endPointService.URL_RRMS_DATEWISE_MSISDN_COUNT_REPORTS
    // + '&startDate=' + this.startDateVal + '&endDate=' + this.endDateVal + '&noofdays=' + this.noOfDaysValue
  +'&orgId=' + data;
  // +'&country='+this.rrmsDashboardForm.get('VPMNCountry').value 
  // +'&networkData='+this.rrmsDashboardForm.get('VPMNnetwork').value
  // + '&customerType=' + this.rrmsDashboardForm.get('customerType').value 
  // // + '&offerStatus=' + this.rrmsDashboardForm.get('offerStatus').value
  // + '&roamOrgId=' + this.rrmsDashboardForm.get('VPMNtadig').value ;

  this.backendApiService.callToApi(rrms_datewise_msisdn_count_reports).subscribe((data) => {
    this.datewiseMsisdnCountBarGraph(data);
  });


    // graph 3
    let pack_activation_success_reports = this.endPointService.URL_RRMS_PACK_ACTIVATION_SUCCESS_REPORTS
      // + '&startDate=' + this.startDateVal + '&endDate=' + this.endDateVal + '&noofdays=' + this.noOfDaysValue 
      + '&orgId=' + data;
      // +'&country='+this.rrmsDashboardForm.get('VPMNCountry').value 
      // +'&networkData='+this.rrmsDashboardForm.get('VPMNnetwork').value
      // + '&customerType=' + this.rrmsDashboardForm.get('customerType').value
      // // + '&offerStatus=' + this.rrmsDashboardForm.get('offerStatus').value
      // + '&roamOrgId=' + this.rrmsDashboardForm.get('VPMNtadig').value;
    this.backendApiService.callToApi(pack_activation_success_reports).subscribe((data) => {
      if( data.ByRegion != undefined && data.ByRegion.length>0){
      data.ByRegion[2]['yAxis'] = 1;
      data.ByRegion[2]['type'] = 'line';
      this.packActivationSuccessBarGraph(data);
      }
      else{

        
      this.packActivationSuccessBarGraph(data);
      }
    });

    // graph 4 

    let pack_activation_failure_reports = this.endPointService.URL_RRMS_PACK_ACTIVATION_FAILURE_REPORTS
      // + '&startDate=' + this.startDateVal + '&endDate=' + this.endDateVal + '&noofdays=' + this.noOfDaysValue 
      + '&orgId=' + data;
      // +'&country='+this.rrmsDashboardForm.get('VPMNCountry').value 
      // +'&networkData='+this.rrmsDashboardForm.get('VPMNnetwork').value
      // + '&customerType=' + this.rrmsDashboardForm.get('customerType').value
      // // + '&offerStatus=' + this.rrmsDashboardForm.get('offerStatus').value
      // + '&roamOrgId=' + this.rrmsDashboardForm.get('VPMNtadig').value;
    this.backendApiService.callToApi(pack_activation_failure_reports).subscribe((data) => {
      if(data.ByRegion[0]['data'].length ==0)
      {
        data ='[]';
        this.packActivationFailureBarGraph(data);
      }
      else{

        
        for (var i = 0; i < data.ByRegion[0]['data'].length; i++) {

          if (data.ByRegion[0]['data'][i].name == '') {
            data.ByRegion[0]['data'][i].name ='No Response' ;

          }
          if (data.ByRegion[0]['data'][i].name == '\"0' ) {
            data.ByRegion[0]['data'][i].name ='1005' ;

          }
          if (data.ByRegion[0]['data'][i].name == '777' ) {
            data.ByRegion[0]['data'][i].name ='no response' ;

          }
        }
      this.packActivationFailureBarGraph(data);
      }
    });

    // graph 5
    let pack_deactivation_success_reports = this.endPointService.URL_RRMS_PACK_DEACTIVATION_SUCCESS_REPORTS
      // + '&startDate=' + this.startDateVal + '&endDate=' + this.endDateVal + '&noofdays=' + this.noOfDaysValue 
      + '&orgId=' + data;
      // +'&country='+this.rrmsDashboardForm.get('VPMNCountry').value 
      // +'&networkData='+this.rrmsDashboardForm.get('VPMNnetwork').value
      // + '&customerType=' + this.rrmsDashboardForm.get('customerType').value
      // // + '&offerStatus=' + this.rrmsDashboardForm.get('offerStatus').value
      // + '&roamOrgId=' + this.rrmsDashboardForm.get('VPMNtadig').value;

    this.backendApiService.callToApi(pack_deactivation_success_reports).subscribe((data) => {
      if( data.ByRegion != undefined && data.ByRegion.length>0){
      data.ByRegion[2]['yAxis'] = 1;
      data.ByRegion[2]['type'] = 'line';
      this.packDeactivationSuccessBarGraph(data);}
      else{
        
      this.packDeactivationSuccessBarGraph(data);
      }
    });

    // graph 6 

    let pack_deactivation_failure_reports = this.endPointService.URL_RRMS_PACK_DEACTIVATION_FAILURE_REPORTS
      // + '&startDate=' + this.startDateVal + '&endDate=' + this.endDateVal + '&noofdays=' + this.noOfDaysValue 
      + '&orgId=' + data;
      // +'&country='+this.rrmsDashboardForm.get('VPMNCountry').value 
      // +'&networkData='+this.rrmsDashboardForm.get('VPMNnetwork').value
      // + '&customerType=' + this.rrmsDashboardForm.get('customerType').value
      // // + '&offerStatus=' + this.rrmsDashboardForm.get('offerStatus').value
      // + '&roamOrgId=' + this.rrmsDashboardForm.get('VPMNtadig').value;
    this.backendApiService.callToApi(pack_deactivation_failure_reports).subscribe((data) => {

      if(data.ByRegion[0]['data'].length ==0)
      {
        data ='[]';
        this.packDeactivationFailureBarGraph(data);
      }
      else{

        
        for (var i = 0; i < data.ByRegion[0]['data'].length; i++) {

          if (data.ByRegion[0]['data'][i].name == '') {
            data.ByRegion[0]['data'][i].name ='No Response' ;

          }
          if (data.ByRegion[0]['data'][i].name == '\"0' ) {
            data.ByRegion[0]['data'][i].name ='1005' ;

          }
          if (data.ByRegion[0]['data'][i].name == '777' ) {
            data.ByRegion[0]['data'][i].name ='no response' ;

          }
        }
      this.packDeactivationFailureBarGraph(data);
      }
    });
   

  }


  // getTadig() {

  //   this.backendApiService.callToApi(
  //     this.endpointsService.URL_GET_VPMN_TADIGS).
  //     subscribe(response => {
  //       if (response.length === 0) {
  //         return;
  //       }
  //       this.vpmnTadigList = response;
  //       this.rrmsDashboardForm.get('VPMNtadig')
  //         .setValue(response[0].orgId, {onlySelf: true});
  //     });

  // }

  
  getCountryDetails() {
    this.backendApiService.callToApi(this.endpointsService.COUNTRY_DETAILS).subscribe(res => {
      this.country = res;
    });
  }

  networkValues() {
    this.getNetworkDetails()
  }

  getNetworkDetails() {
    let cntry = this.rrmsDashboardForm.get('country').value.split("_")[1]
    
    this.backendApiService.callToApi(this.endpointsService.NETWORK_DETAILS
      + "&country=" + cntry)
      .subscribe(res => {
        this.network = res;
      });
  }

  async getVPMNCountryDetails() {
    const apiUrl = this.endpointsService.COUNTRY_DETAILS + '&userName=' + sessionStorage.getItem('ecowas_user_name');
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.vpmnCountryList = response;
    });
  }

  getVpmnNetworkAccordingToCountry(event: any) {
    if (event.target.value === 'ALL') {
      this.rrmsDashboardForm.controls.vpmnNetwork.setValue('ALL', { onlySelf: true });
    } else {
      this.getVpmnNetworkList(event.target.value).then();
    }
  }

  async getVpmnNetworkList(country: string) {
    // if(this.orgId == '274'  || this.orgId == '110'){
    //   const apiUrl1 = 'https://loginapp1.tevas.in/TarrifServlet?reportType=getOperator' + 
    //     '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;
    //   this.backendApiService.callToApi(apiUrl1).subscribe(response => {
    //     this.vpmnNetworkList = response;
    //     if (this.vpmnNetworkList && this.vpmnNetworkList.length > 0) {
    //       this.rrmsDashboardForm.controls.VPMNnetwork.setValue(response[0].operator, { onlySelf: true });
    //     }
    //     this.getTadig();
    //   });
    // }
      
    //   else{
    const apiUrl1 = this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      this.vpmnNetworkList = response;
      if (this.vpmnNetworkList && this.vpmnNetworkList.length > 0) {
        this.rrmsDashboardForm.controls.VPMNnetwork.setValue(response[0].operator, { onlySelf: true });
      }
      this.getTadig();
    });
  // }
  }


  getTadig() {
    if(this.rrmsDashboardForm.controls.VPMNCountry.value == '' || this.rrmsDashboardForm.controls.VPMNnetwork.value == ''){
      this.vpmnTadigList = [];
      this.rrmsDashboardForm.get('VPMNtadig')
          .setValue('', {onlySelf: true});
    }
    // else{
    //   if(this.orgId == '274' || this.orgId == '110'){
    //     this.backendApiService.callToApi(
    //       'https://loginapp1.tevas.in/CampaignServlet?requestType=getTapCodeList'+
    //       '&country=' + this.rrmsDashboardForm.get('VPMNCountry').value +
    //       '&operator=' + this.rrmsDashboardForm.get('VPMNnetwork').value).
    //       subscribe(response => {
    //         if (response.length === 0) {
    //           return;
    //         }
    //         this.vpmnTadigList = response;
    //         this.rrmsDashboardForm.get('VPMNtadig')
    //           .setValue(response[0].tapCode, { onlySelf: true });
    //       });
    //   }
       
       else{
    this.backendApiService.callToApi(
      this.endpointsService.URL_GET_CAMPAIGN_TADIG + '&country=' + this.rrmsDashboardForm.get('VPMNCountry').value +
      '&operator=' + this.rrmsDashboardForm.get('VPMNnetwork').value).
      subscribe(response => {
        if (response.length === 0) {
          return;
        }
        this.vpmnTadigList = response;
        this.rrmsDashboardForm.get('VPMNtadig')
          .setValue(response[0].tapCode, {onlySelf: true});
      });
    }
  // }
  }

  get f() {
    return this.rrmsDashboardForm.controls;
  }

  reset() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
    // this.spinnerService.show();
    // this.createFilterForm();
    // this.showTable = false;
    
  }



  msisdnCountBarGraph(data: any) {
    var chart = Highcharts.chart(
      {
        chart: {
          renderTo: 'msisdnCountBarGraph',
          type: 'column',
          backgroundColor: '#f3f3ff',
          borderRadius: 10,
          animation: {
            duration: 1500,
          },
        },
        title: {
          // text: 'Total Msisdn and Unique Msisdn count '
          text: 'Network wise total ULs and unique roamers count '
        },
        exporting: {
          filename: 'Network wise total ULs and unique roamers count'
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          type: 'category',
          title: {
            text: 'Network',
          },
          crosshair: true,
        },
        yAxis: [
          {
            tickAmount: 5,
            title: {
              text: 'No. of Msisdns',
            },
          },
          // {
          //   title: {
          //     text: '',
          //   },
          // },
          // {tickAmount:5,
          //   staticScale:100,
          //   ceiling:100,
          //   opposite: true,
          //   title: {
          //     text: 'Success Rate',
          //   },
          // },
        ],
        tooltip: {
          shared: true,
          formatter: this.formatterFunction,
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: (event: any) => {
                  console.log(event);
                  // this.countryName = event.point.name;
                  // this.getOrgId(event.point.name, event.point.y);
                },
              },
            },
          },
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        series: data.ByRegion,
      },
      function (chart) {
        var arr = chart.options.exporting.buttons.contextButton.menuItems;
        var index = arr.indexOf("viewData");
        if (index !== -1) arr.splice(index, 1);
        // on complete
        if (chart.series.length < 1) {
          var texto = chart.renderer
            .text('No Data Available ', 140, 120)
            .css({
              color: '#4572A7',
              fontSize: '16px',
            })
            .add();
          var textBBox = texto.getBBox();
          var x = chart.plotLeft + chart.plotWidth * 0.5 - textBBox.width * 0.5;
          var y =
            chart.plotTop + chart.plotHeight * 0.5 - textBBox.height * 0.5;
          texto.attr({ x: x, y: y, id: 'xtratext' });
        }
      }
    );
  }
  datewiseMsisdnCountBarGraph(data: any) {
    var chart = Highcharts.chart(
      {
        chart: {
          renderTo: 'datewiseMsisdnCountBarGraph',
          type: 'column',
          backgroundColor: '#f3f3ff',
          borderRadius: 10,
          animation: {
            duration: 1500,
          },
        },
        title: {
          text: 'Date wise total ULs and unique roamers count '
        },
        exporting: {
          filename: 'Date wise total ULs and unique roamers count '
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          type: 'category',
          title: {
            text: 'Date',
          },
          crosshair: true,
        },
        yAxis: [
          {
            tickAmount: 5,
            title: {
              text: 'No. of Msisdns',
            },
          },
          // {
          //   title: {
          //     text: '',
          //   },
          // },
          // {tickAmount:5,
          //   staticScale:100,
          //   ceiling:100,
          //   opposite: true,
          //   title: {
          //     text: 'Success Rate',
          //   },
          // },
        ],
        tooltip: {
          shared: true,
          formatter: this.formatterFunction,
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: (event: any) => {
                  console.log(event);
                  // this.countryName = event.point.name;
                  // this.getOrgId(event.point.name, event.point.y);
                },
              },
            },
          },
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        series: data.ByRegion,
      },
      function (chart) {
        // on complete
        if (chart.series.length < 1) {
          var texto = chart.renderer
            .text('No Data Available ', 140, 120)
            .css({
              color: '#4572A7',
              fontSize: '16px',
            })
            .add();
          var textBBox = texto.getBBox();
          var x = chart.plotLeft + chart.plotWidth * 0.5 - textBBox.width * 0.5;
          var y =
            chart.plotTop + chart.plotHeight * 0.5 - textBBox.height * 0.5;
          texto.attr({ x: x, y: y, id: 'xtratext' });
        }
      }
    );
  }
  packActivationSuccessBarGraph(data: any) {
    var chart = Highcharts.chart(
      {
        chart: {
          renderTo: 'packActivationSuccessBarGraph',
          type: 'column',
          backgroundColor: '#f3f3ff',
          borderRadius: 10,
          animation: {
            duration: 1500,
          },
        },
        title: {
          text: 'Pack activation count ( Prepaid system ) '
        },
        exporting: {
          filename: 'Network wise pack activation success '
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          type: 'category',
          title: {
            text: 'Network',
          },
          crosshair: true,
        },
        yAxis: [
          {
            tickAmount: 5,
            title: {
              text: 'No. of Requests',
            },
          },
          // {
          //   title: {
          //     text: '',
          //   },
          // },
          {
            tickAmount: 5,
            staticScale: 100,
            ceiling: 100,
            opposite: true,
            title: {
              text: 'Success Rate',
            },
          },
        ],
        tooltip: {
          shared: true,
          formatter: this.formatterFunction,
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: (event: any) => {
                  console.log(event);
                  // this.countryName = event.point.name;
                  // this.getOrgId(event.point.name, event.point.y);
                },
              },
            },
          },
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        series: data.ByRegion,
      },
      function (chart) {
        // on complete
        if (chart.series.length < 1) {
          var texto = chart.renderer
            .text('No Data Available ', 140, 120)
            .css({
              color: '#4572A7',
              fontSize: '16px',
            })
            .add();
          var textBBox = texto.getBBox();
          var x = chart.plotLeft + chart.plotWidth * 0.5 - textBBox.width * 0.5;
          var y =
            chart.plotTop + chart.plotHeight * 0.5 - textBBox.height * 0.5;
          texto.attr({ x: x, y: y, id: 'xtratext' });
        }
      }
    );
  }
  packActivationFailureBarGraph(data: any) {
    var chart = Highcharts.chart(
      {
        chart: {
          renderTo: 'packActivationFailureBarGraph',
          type: 'column',
          backgroundColor: '#f3f3ff',
          borderRadius: 10,
          animation: {
            duration: 1500,
          },
        },
        title: {
          text: 'Pack activation failure reasons '
        },
        exporting: {
          filename: 'Pack activation failure reasons '
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          type: 'category',
          title: {
            text: 'Failure Reason',
          },
          crosshair: true,
        },
        yAxis: [
          {
            tickAmount: 5,
            title: {
              text: 'Failure Count',
            },
          },
          // {
          //   title: {
          //     text: '',
          //   },
          // },
          // {
          //   tickAmount: 5,
          //   staticScale: 100,
          //   ceiling: 100,
          //   opposite: true,
          //   title: {
          //     text: 'Failure Rate',
          //   },
          // },
        ],
        tooltip: {
          shared: true,
          formatter: this.formatterFunction,
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: (event: any) => {
                  console.log(event);
                  // this.countryName = event.point.name;
                  // this.getOrgId(event.point.name, event.point.y);
                },
              },
            },
          },
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        series: data.ByRegion,
      },
      function (chart) {
        // on complete
        if (chart.series.length < 1) {
          var texto = chart.renderer
            .text('No Data Available ', 140, 120)
            .css({
              color: '#4572A7',
              fontSize: '16px',
            })
            .add();
          var textBBox = texto.getBBox();
          var x = chart.plotLeft + chart.plotWidth * 0.5 - textBBox.width * 0.5;
          var y =
            chart.plotTop + chart.plotHeight * 0.5 - textBBox.height * 0.5;
          texto.attr({ x: x, y: y, id: 'xtratext' });
        }
      }
    );
  }
  packDeactivationSuccessBarGraph(data: any) {
    var chart = Highcharts.chart(
      {
        chart: {
          renderTo: 'packDeactivationSuccessBarGraph',
          type: 'column',
          backgroundColor: '#f3f3ff',
          borderRadius: 10,
          animation: {
            duration: 1500,
          },
        },
        title: {
          text: 'Pack deactivation count ( Prepaid system) '
        },
        exporting: {
          filename: 'Network wise pack deactivation success '
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          type: 'category',
          title: {
            text: 'Network',
          },
          crosshair: true,
        },
        yAxis: [
          {
            tickAmount: 5,
            title: {
              text: 'No. of Requests',
            },
          },
          // {
          //   title: {
          //     text: '',
          //   },
          // },
          {
            tickAmount: 5,
            staticScale: 100,
            ceiling: 100,
            opposite: true,
            title: {
              text: 'Success Rate',
            },
          },
        ],
        tooltip: {
          shared: true,
          formatter: this.formatterFunction,
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: (event: any) => {
                  console.log(event);
                  // this.countryName = event.point.name;
                  // this.getOrgId(event.point.name, event.point.y);
                },
              },
            },
          },
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        series: data.ByRegion,
      },
      function (chart) {
        // on complete
        if (chart.series.length < 1) {
          var texto = chart.renderer
            .text('No Data Available ', 140, 120)
            .css({
              color: '#4572A7',
              fontSize: '16px',
            })
            .add();
          var textBBox = texto.getBBox();
          var x = chart.plotLeft + chart.plotWidth * 0.5 - textBBox.width * 0.5;
          var y =
            chart.plotTop + chart.plotHeight * 0.5 - textBBox.height * 0.5;
          texto.attr({ x: x, y: y, id: 'xtratext' });
        }
      }
    );
  }
  packDeactivationFailureBarGraph(data: any) {
    var chart = Highcharts.chart(
      {
        chart: {
          renderTo: 'packDeactivationFailureBarGraph',
          type: 'column',
          backgroundColor: '#f3f3ff',
          borderRadius: 10,
          animation: {
            duration: 1500,
          },
        },
        title: {
          text: 'Pack deactivation failure reasons'
        },
        exporting: {
          filename: 'Pack deactivation failure reasons'
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          type: 'category',
          title: {
            text: 'Failure Reason',
          },
          crosshair: true,
        },
        yAxis: [
          {
            tickAmount: 5,
            title: {
              text: 'Failure Count',
            },
          },
          // {
          //   title: {
          //     text: '',
          //   },
          // },
          // {
          //   tickAmount: 5,
          //   staticScale: 100,
          //   ceiling: 100,
          //   opposite: true,
          //   title: {
          //     text: 'Failure Rate',
          //   },
          // },
        ],
        tooltip: {
          shared: true,
          formatter: this.formatterFunction,
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: (event: any) => {
                  console.log(event);
                  // this.countryName = event.point.name;
                  // this.getOrgId(event.point.name, event.point.y);
                },
              },
            },
          },
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        series: data.ByRegion,
      },
      function (chart) {
        // on complete
        if (chart.series.length < 1) {
          var texto = chart.renderer
            .text('No Data Available ', 140, 120)
            .css({
              color: '#4572A7',
              fontSize: '16px',
            })
            .add();
          var textBBox = texto.getBBox();
          var x = chart.plotLeft + chart.plotWidth * 0.5 - textBBox.width * 0.5;
          var y =
            chart.plotTop + chart.plotHeight * 0.5 - textBBox.height * 0.5;
          texto.attr({ x: x, y: y, id: 'xtratext' });
        }
      }
    );
  }
  smsNotificationSuccessBarGraph(data: any) {
    var chart = Highcharts.chart(
      {
        chart: {
          renderTo: 'smsNotificationSuccessBarGraph',
          type: 'column',
          backgroundColor: '#f3f3ff',
          borderRadius: 10,
          animation: {
            duration: 1500,
          },
        },
        title: {
          text: 'SMS notification success '
        },
        exporting: {
          filename: 'SMS notification success '
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          type: 'category',
          crosshair: true,
        },
        yAxis: [
          {
            tickAmount: 5,
            title: {
              text: 'No. of Requests',
            },
          },
          // {
          //   title: {
          //     text: '',
          //   },
          // },
          {
            tickAmount: 5,
            staticScale: 100,
            ceiling: 100,
            opposite: true,
            title: {
              text: 'Success Rate',
            },
          },
        ],
        tooltip: {
          shared: true,
          formatter: this.formatterFunction,
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: (event: any) => {
                  console.log(event);
                  // this.countryName = event.point.name;
                  // this.getOrgId(event.point.name, event.point.y);
                },
              },
            },
          },
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        series: data.ByRegion,
      },
      function (chart) {
        // on complete
        if (chart.series.length < 1) {
          var texto = chart.renderer
            .text('No Data Available ', 140, 120)
            .css({
              color: '#4572A7',
              fontSize: '16px',
            })
            .add();
          var textBBox = texto.getBBox();
          var x = chart.plotLeft + chart.plotWidth * 0.5 - textBBox.width * 0.5;
          var y =
            chart.plotTop + chart.plotHeight * 0.5 - textBBox.height * 0.5;
          texto.attr({ x: x, y: y, id: 'xtratext' });
        }
      }
    );
  }
  smsNotificationFailureBarGraph(data: any) {
    var chart = Highcharts.chart(
      {
        chart: {
          renderTo: 'smsNotificationFailureBarGraph',
          type: 'column',
          backgroundColor: '#f3f3ff',
          borderRadius: 10,
          animation: {
            duration: 1500,
          },
        },
        title: {
          text: 'SMS notification failure '
        },
        exporting: {
          filename: 'SMS notification failure '
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          type: 'category',
          crosshair: true,
        },
        yAxis: [
          {
            tickAmount: 5,
            title: {
              text: 'No. of Requests',
            },
          },
          // {
          //   title: {
          //     text: '',
          //   },
          // },
          // {
          //   tickAmount: 5,
          //   staticScale: 100,
          //   ceiling: 100,
          //   opposite: true,
          //   title: {
          //     text: 'Failure Rate',
          //   },
          // },
        ],
        tooltip: {
          shared: true,
          formatter: this.formatterFunction,
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: (event: any) => {
                  console.log(event);
                  // this.countryName = event.point.name;
                  // this.getOrgId(event.point.name, event.point.y);
                },
              },
            },
          },
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        series: data.ByRegion,
      },
      function (chart) {
        // on complete
        if (chart.series.length < 1) {
          var texto = chart.renderer
            .text('No Data Available ', 140, 120)
            .css({
              color: '#4572A7',
              fontSize: '16px',
            })
            .add();
          var textBBox = texto.getBBox();
          var x = chart.plotLeft + chart.plotWidth * 0.5 - textBBox.width * 0.5;
          var y =
            chart.plotTop + chart.plotHeight * 0.5 - textBBox.height * 0.5;
          texto.attr({ x: x, y: y, id: 'xtratext' });
        }
      }
    );
  }
  formatterFunction(this: any): string {
    let s: any = [];
    let v = 0;
    $.each(this.points, function (i, point: any) {
      if (v === 0) {
        s.push('<span style="font-size: 13px">' + point.key + '</span><br/>');
      }
      v++;
      if (point.series.name === 'Success Rate' || point.series.name === 'Failure Rate') {
        s.push(
          '<span style="color:' +
          point.series.color +
          '">' +
          point.series.name +
          ' : ' +
          point.y.toFixed(2) +
          '<span> %</br>'
        );
      } else {
        s.push(
          '<span style="color:' +
          point.series.color +
          '">' +
          point.series.name +
          ' : ' +
          formatValue(point.y) +
          '<span></br>'
        );
      }
    });
    return s.join('');
  }




}

function formatValue(input: any) {
  var exp,
    suffixes = ['k', 'M', 'G', 'T', 'P', 'E'];

  if (Number.isNaN(input)) {
    return null;
  }

  if (input < 1000) {
    return input;
  }

  exp = Math.floor(Math.log(input) / Math.log(1000));

  return (input / Math.pow(1000, exp)).toFixed(2) + suffixes[exp - 1];
}
